import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  getByGeneric: async (id) => {
    return request(`${API_URL}/photos/get-by-generic/${id}`, 'get');
  },
};
